const calendar = {
  'calendar.title': 'Calendar',
  'calendar.today': 'Today',
  'calendar.month': 'Month',
  'calendar.week': 'Week',
  'calendar.allTeams': 'All teams',
  'calendar.ownOnly': 'Mine only',
  'calendar.error.load': 'Calendar could not be loaded',
  'calendar.weekday.1': 'Mon',
  'calendar.weekday.2': 'Tue',
  'calendar.weekday.3': 'Wed',
  'calendar.weekday.4': 'Thu',
  'calendar.weekday.5': 'Fri',
  'calendar.weekday.6': 'Sat',
  'calendar.weekday.7': 'Sun',
  'calendar.type.ARBEITSZEIT_OFFICE': 'Working time (office)',
  'calendar.type.ARBEITSZEIT_HOME_OFFICE': 'Working time (home office)',
  'calendar.type.URLAUB_GENEHMIGT': 'Vacation approved',
  'calendar.type.URLAUB_OFFEN': 'Vacation request pending',
  'calendar.type.ABWESENHEIT': 'Absence',
  'calendar.type.ABWESENHEIT_FZT': 'FZT (Comp time off)',
  'calendar.type.VERTRETUNG': 'Substitute',
  'calendar.grouped.count': '{n} entries',
};

export default calendar;
